import React from 'react';

import { required } from '@swf/core/utils/validators';

import TextInput from '../../../../../TextInput/TextInput';

import {
  TXTWCL_Document_number,
  TXTWCL_Please_enter_your_identificati_ELL_1
} from './DocumentNumberField.messages.json';

const parse = (value: string) => value.replace(/[^A-Za-z0-9]/g, '');

const DocumentNumberField: React.FC = () => (
  <TextInput
    id={'docNumber'}
    maxLength={20}
    parse={parse}
    label={TXTWCL_Document_number}
    validators={[required(TXTWCL_Please_enter_your_identificati_ELL_1)]}
    checkDisabled
  />
);

export default DocumentNumberField;
